<fr8bot-ui-icon class="toast__icon" [name]="iconName()" [size]="20" />

<div class="toast__body">
  @if (title()) {
    <div class="toast__title">{{ title() }}</div>
  }

  <div class="toast__message" [innerHTML]="message()"></div>
</div>

<button class="toast__close" type="button" aria-label="Close" (click)="dismiss.emit()">
  <fr8bot-ui-icon [name]="'menu-x'" [size]="16" />
</button>
